import { useQuery } from '@tanstack/react-query';
import { DropdownEntry } from '../types';
import { fetchDropdownEntries } from '../api';
import { DropdownIdentifier } from '../constants';

export const useDropdownEntries = <TEntry extends DropdownEntry>(
  dropdownIdentifier: DropdownIdentifier) => {
  return useQuery<TEntry[]>({
    queryKey: ['dropdownEntries', dropdownIdentifier],
    queryFn: () => fetchDropdownEntries<TEntry>(dropdownIdentifier),
  });
};
